import Component from "@glimmer/component";
import bodyClass from "discourse/helpers/body-class";

export default class AddCirclesCategoryBodyClass extends Component {
  static shouldRender(args) {
    return (
      args?.category?.is_circle || // above-category-heading
      args?.model?.category?.is_circle // topic-above-post-stream
    );
  }

  // adds a class to the body
  <template>{{bodyClass "circles-category--is-circle"}}</template>
}
